var path = 'src/app/components/general-ledger/transactions/gl-transactions.template.html';
var html = "<gl-account-list detail-link=\"#!/general-ledger/transactions\"></gl-account-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;